import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SET_CURRENT_ACTIVE_CATELOGE_ID,
  SET_CURRENT_ACTIVE_CATEGORY_ID,
  GET_ALL_GLOBAL_CATELOGE,
  GET_ALL_GLOBAL_CATELOGE_CATEGORY,
  GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM,
  SET_CURRENT_ITEM_CATEGORY,
  SET_ALL_COMPLETE_ITEMS,
} from "../../types";
import Alert from "react-s-alert";
import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - GET ALL GLOBAL CATELOGE
 *****************************************/
export const get_all_global_cateloge_menu =
  (token, onSuccessCateloge) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_all_global_cateloge_menu = await axios.get(
        `${serverApi}/catalogue`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_all_global_cateloge_menu.status === 200) {
        dispatch({
          type: GET_ALL_GLOBAL_CATELOGE,
          payload: get_all_global_cateloge_menu.data,
        });
        onSuccessCateloge(false);
        dispatch({
          type: SET_CURRENT_ACTIVE_CATELOGE_ID,
          payload:
            get_all_global_cateloge_menu?.data &&
            get_all_global_cateloge_menu?.data[0]?._id,
        });
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC - GET ALL GLOBAL CATELOGE CATEGORY
 ********************************************/
export const get_all_global_cateloge_menu_category =
  (catelogeId, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_all_global_cateloge_menu_category = await axios.get(
        `${serverApi}/catalogue/${catelogeId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_all_global_cateloge_menu_category.status === 200) {
        dispatch({
          type: GET_ALL_GLOBAL_CATELOGE_CATEGORY,
          payload: get_all_global_cateloge_menu_category?.data?.items,
        });
        dispatch({
          type: SET_CURRENT_ACTIVE_CATEGORY_ID,
          payload:
            get_all_global_cateloge_menu_category?.data &&
            get_all_global_cateloge_menu_category?.data?.items[0]?.category
              ?._id,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC - GET ALL GLOBAL CATELOGE CATEGORY ITEM
 ************************************************/
export const get_all_global_cateloge_menu_category_item =
  (categoryId, catlogueId, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_all_global_cateloge_menu_category_item = await axios.get(
        `${serverApi}/vendor/items/${categoryId}?catlogue_id=${catlogueId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_all_global_cateloge_menu_category_item.status === 200) {
        dispatch({
          type: GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM,
          payload: get_all_global_cateloge_menu_category_item.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - ADD OFFERS AND EVENTS ACTION
 *****************************************/
export const add_global_cateloge_menu_category_item =
  (formData, token, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_diner_reservaton = await axios.post(
        `${serverApi}/vendor/items?add=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_diner_reservaton.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({ type: SET_CURRENT_ITEM_CATEGORY, payload: {} });
        dispatch({ type: SET_CURRENT_ACTIVE_CATELOGE_ID, payload: "" });
        dispatch({ type: GET_ALL_GLOBAL_CATELOGE, payload: [] });
        dispatch({ type: SET_CURRENT_ACTIVE_CATEGORY_ID, payload: "" });
        dispatch({ type: GET_ALL_GLOBAL_CATELOGE_CATEGORY, payload: [] });
        dispatch({ type: GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM, payload: [] });
        dispatch({ type: SET_ALL_COMPLETE_ITEMS, payload: [] });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
